/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2020-12-06 10:30:38
 */

import SaasAccountConfig from "../saasAccountConfig";
import {Toast} from "src/util/toast";
import {default as CellOperate} from "src/components/agGridComponent/cellOperate";
import {IconBtnItem} from "src/components/iconBtnGroup/iconBtnGroup";
import {ColDefCustom, default as AgGridVueCustomTsx} from "src/components/agGridCustom/agGridVueCustomTsx";
import SaasAccountConfigApi,{SaasAccountConfigDOI} from "../api/saasAccountConfigApi";
import _ from 'lodash'
import ListPageService from 'src/types/ListPage';
import override from "src/dectorators/override";
import {QueryFormVOI} from "src/components/queryForm/queryForm";
import Input from 'src/types/iview/Input';
import EnumOperates from 'src/enums/enumOperates';
import alertSaasAccountOperateModal from '../saasAccountOperateModal';

export default class SaasAccountConfigService extends ListPageService {
	ctx: SaasAccountConfig;

	constructor (ctx: SaasAccountConfig) {
	    super()
		this.ctx = ctx
	}

    @override
	createColumns (): ColDefCustom [] {
		let t = this
		return [
			{
				headerName: '系统名称',
				field: 'system_name',
				minWidth: 190
			},
			{
				headerName: '系统英文名称',
				field: 'english_system_name',
				minWidth: 190
			},
			{
				headerName: '账号名称',
				field: 'account_name',
				minWidth: 80
			},
			{
				headerName: '管理员姓名',
				field: 'real_name',
				minWidth: 100
			},
			{
				headerName: '管理手机号',
				field: 'mobile',
				minWidth: 190
			},
			{
				headerName: '过期时间',
				field: 'expiration_time',
				minWidth: 190
			},
			{
				headerName: '操作',
				field: 'operate',
				minWidth: 120,
				maxWidth: 120,
				cellRendererFramework: CellOperate,
				cellRendererFrameworkOpt: [
					{
						text: '修改',
						async click (params) {
							let data:SaasAccountConfigDOI.RowDataI= params.data
                            let res = await alertSaasAccountOperateModal(EnumOperates.Update.getName(), data)
                            if(res) {
                                t.searchTable()
                            }
						}
					}, {
						text: '删除',
						async click (params) {
							let res = await Toast.confirm()
							if (!res) {
								return
							}
							let data: SaasAccountConfigDOI.RowDataI = params.data
							await t.delete([data.id])
						}
					}
				]
			},
		]
	}

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            
            {
                component: Input,
                width: 400,
                label: '',
                labelWidth:0,
                field: 'keyword',
                props: { value: '', placeholder: '请输入账号名称/管理员名称/手机号' },
            },
        ];
    }

    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '新增',
                async onClick() {
                    let res = await alertSaasAccountOperateModal(EnumOperates.Add.getName())
                    if(res) {
                        t.searchTable()
                    }
                },
            }
        ];
    }

	async delete(ids: number[]) {
		let {code} = await SaasAccountConfigApi.delete(ids[0])
		if (code=== 0) {
			Toast.success('删除成功')
			this.searchTable()
		}
	}

	@override
	initSearchParams (): void {
		this.ctx.searchParams = this.ctx.queryForm.getQueryObj<SaasAccountConfigDOI.QueryRowDataParamsI>()
		this.ctx.currentPage = 1
	}

    @override
	async searchTable () {
		let ctx = this.ctx
		let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
		ag.showLoading()
		let {code, data} = await SaasAccountConfigApi.searchList({
			...ctx.searchParams,
			page_size: ctx.pageSize,
			page_index: ctx.currentPage
		})
		ag.hideLoading()

		if (code === 0) {
			ctx.rowData = data.data_info || []
			ctx.total = data.page_count
		}
	}

}